import i18n from '@/utils/i18n';
import React from 'react';
import { Icons, Tooltip, Typography } from '@usepepper/sprout-kit-ui';
import { useTheme } from '@/contexts/theme-context';
import { View } from 'react-native';

const ICON_SIZE = 12;

export const PeakPriceProtectionIcon: React.FC = () => {
  const theme = useTheme();

  return (
    <Tooltip delay={0} placement="top">
      <Tooltip.Trigger>
        <View
          accessibilityLabel={i18n.t('price_protected')}
          accessibilityRole="image"
        >
          <Icons.Shield
            color={theme.sk.color.text.secondary}
            size={ICON_SIZE}
          />
        </View>
      </Tooltip.Trigger>
      <Tooltip.Content
        animation={null}
        backgroundColor="$bgPrimaryDefault"
        borderColor="$borderPrimary"
        borderRadius="$8"
        borderWidth={1}
        paddingHorizontal="$8"
        paddingVertical="$4"
      >
        <Typography size="$sm">{i18n.t('price_protected')}</Typography>
      </Tooltip.Content>
    </Tooltip>
  );
};
